import { Component } from '@angular/core';
import { NavController,AlertController,ToastController,ModalController, NavParams, ViewController } from 'ionic-angular';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';

import { addIngredient } from './addIngredient';
import { Params } from '../params';
import * as firebase from 'firebase/app';

@Component({
  selector: 'page-recipes',
  templateUrl: 'recipes.html'
})
export class RecipesPage{
  recipes;
  items;
  money;
  ingredients;
  filter:string;
  constructor(
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
  ){
    firebase.database().ref('/ingredients').orderByChild("active").equalTo(true).once('value').then((snapshot)=>{
      this.ingredients = snapshot.val();
      /* this.recipesRef = af.list('/recipes');
      this.recipesRef.subscribe(x => {
        x = x.filter((item) => {return (item.deleted==undefined || !item.deleted);});
        let recipes = this.process(x);
        this.items = recipes;
        this.recipes = recipes;
      }); */
    });

    this.filter = "name";
    this.money = Params.money;

  }

  process(x){
    if(this.ingredients){
      let recipes = [];
      for(let i=0;i<x.length;i++){
        let r = x[i];
        let c = 0;
        if(typeof r.ingredients!="undefined"){
          for(let j=0;j<r.ingredients.length;j++){
            let key = r.ingredients[j].key;
            if(typeof this.ingredients[key]!="undefined"){
              c = c + Number(this.ingredients[key]["netcost"])*r.ingredients[j].qtym;
            }
          }
        }
        r.totalcost = Math.trunc(c);
        recipes.push(r);
      }
      return recipes;
    }else{
      return null;
    }
  }

  remove(i){
    let confirm = this.alertCtrl.create({
      title: 'Eliminar',
      message: '¿Está seguro de eliminar '+i.name+'?',
      buttons: [
        {
          text: 'Cancelar',
          handler: () => {
            console.log('Disagree clicked');
          }
        },
        {
          text: 'Si, deseo eliminarlo',
          handler: () => {
            i.deleted = true;
            i.active = false;
            i.deletedBy = Params.md5(Params.USER_DATA.email);
            /* this.recipe = this.af.object('recipes/'+i.key);
            this.recipe.set(i).then(_ => {
              let toast = this.toastCtrl.create({
                message: i.name+" eliminado exitosamente",
                duration: 3000
              });
              toast.present();
            }); */
          }
        }
      ]
    });
    confirm.present();
  }

  ionViewWillEnter() {
    firebase.database().ref('/ingredients').orderByChild("active").equalTo(true).once('value').then((snapshot)=>{
      this.ingredients = snapshot.val();
    });
  }


  addIngredient(i){
    let modal = this.modalCtrl.create(addIngredient, {item:i});
    modal.present();
  }

  newItem(i){
    let modal = this.modalCtrl.create(RecipePage, {item:i});
    modal.present();
  }

  initializeItems() {
    this.items = this.recipes;
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return ((item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) || (item.$key.toLowerCase().indexOf(val.toLowerCase()) > -1));
      })
    }
  }


}
@Component({selector: 'page-recipe', templateUrl: 'recipe.html'})
export class RecipePage {

  title;
  addForm: FormGroup;
  edit:boolean = false;
  constructor(
    public params: NavParams,
    public viewCtrl: ViewController,
    private builder: FormBuilder,
    public toastCtrl: ToastController
  ) {

    this.addForm = builder.group({
      'key': ['', Validators.required],
      'name': ['', Validators.required],
      'elaboration': [''],
      'proteins': [0],
      'lipids': [0],
      'carbohydrates': [0],
      'calories': [0],
      'duration': [3, Validators.required],
      'active' : [true, Validators.required]
    })

    this.title = "Nueva Receta";
    console.log(this.params.get("item"));
    if(this.params.get("item")){
      let recipe = this.params.get("item");
      this.edit = true;
      this.title = "Editar Receta";
      this.addForm = builder.group({
        'key': [recipe["key"], Validators.required],
        'name': [recipe["name"], Validators.required],
        'elaboration': [recipe["elaboration"]],
        'proteins': [recipe["proteins"]],
        'lipids': [recipe["lipids"]],
        'carbohydrates': [recipe["carbohydrates"]],
        'calories': [recipe["calories"]],
        'duration': [recipe["duration"], Validators.required],
        'active': [recipe["active"]],
        'ingredients': [recipe["ingredients"]],
      });
    }
  }



  save() {
    console.log(this.addForm.value);
    const key = Params.key_parse(this.addForm.value["key"]);
    //this.recipe = this.db.object('recipes/'+key);
    let msg = 'Receta '+this.addForm.value.name+' creado exitosamente';
    if(this.edit){
      msg = 'Receta '+this.addForm.value.name+' editado exitosamente';
      /* this.recipe.set(this.addForm.value).then(_ => {
        let toast = this.toastCtrl.create({
          message: msg,
          duration: 3000
        });
        toast.present();
      }); */
      this.viewCtrl.dismiss();
    }else{
      firebase.database().ref('recipes/'+key).once('value')
        .then((snap)=> {
          if (snap.exists()) {
            let toast = this.toastCtrl.create({
              message: 'El código '+key+' ya está siendo utilizado para otra receta. Utilice otro.',
              duration: 3000
            });
            toast.present();
          }else{
            /* this.recipe.set(this.addForm.value).then(_ => {
              let toast = this.toastCtrl.create({
                message: msg,
                duration: 3000
              });
              toast.present();
            }); */
            this.viewCtrl.dismiss();
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/recipes/recipes.ts